import { Audience } from '@/domain/types/audience';
import { Column } from '@/presentation/components/table';

export const columns: Column<Audience>[] = [
  {
    header: 'Nombre',
    accessor: 'name',
    render: (value) => (
      <span className="text-sm font-medium text-gray-900">
        {value as string}
      </span>
    ),
  },
  {
    header: 'Descripción',
    accessor: 'description',
    render: (value) =>
      value ? (
        <span className="block max-w-md text-left text-sm normal-case text-gray-600">
          {value as string}
        </span>
      ) : (
        <span className="text-gray-500" aria-label="Sin descripción">
          —
        </span>
      ),
  },
  {
    header: 'Estado',
    accessor: 'isActive',
    render: (value) =>
      value ? (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-green-100 px-2.5 py-1 text-xs font-medium text-green-800">
          <span
            className="h-1.5 w-1.5 rounded-full bg-green-600"
            aria-hidden="true"
          />
          Activa
        </span>
      ) : (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-600">
          <span
            className="h-1.5 w-1.5 rounded-full bg-gray-400"
            aria-hidden="true"
          />
          Inactiva
        </span>
      ),
  },
];
